<template>
  <question-base-wrapper
    v-bind="baseWrapperProps"
    :subtitle="computedSubtitle"
  >
    <validation-provider
      v-slot="{ failedRules, failed }"
      :rules="validationRules ? validationRules['field'] : 'required'"
      :name="questionId"
      :vid="`${stepId}_${questionId}`"
      :data-unit-test="`${stepId}_${questionId}`"
    >
      <help-text
        class="mb-6"
        :error="formObserver.validated && failed"
      >
        <p>
          The price shown is for UK Roadside, Local Recovery and Home Start cover.
          <a
            class="text-decoration-underline"
            href="#"
            @click.prevent="showMore = !showMore"
          >{{ showMore ? 'Less details': 'Click here' }}</a>
          <template v-if="!showMore"> for more information on your cover.</template>
        </p>
        <template v-if="showMore">
          <p><strong>Local:</strong> If your breakdown occurs further than 1 mile from your home address (distance may vary depending on provider), usually you, your vehicle and a maximum of 7 passengers will be recovered to the nearest garage which is able to undertake the repair.</p>
          <p><strong>Home Start:</strong> If you break down within 1 mile of your home, usually your vehicle and at least 4 passengers will be recovered and brought to the nearest garage available to undertake the repair.</p>
        </template>
      </help-text>
      <radio
        v-model="questionData[questionFields.field]"
        :name="`${stepId}.${questionId}`"
        :items="options"
        :error="failed"
        :error-messages="getFieldErrors('field', failedRules)"
        :data-test="snakeCase(questionFields.field)"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-cheap-breakdown-cover',
  extends: QuestionBase,
  data () {
    return {
      fields: ['field'],
      breakdownPrice: 0,
      showMore: false,
    };
  },
  created () {
    // Force user to always answer the question
    this.questionData.cheapBreakdownCover = null;
    this.getBreakdownPrice();
  },
  computed: {
    computedSubtitle () {
      return `<p>Breakdown cover for a car like yours is available from just £${this.breakdownPrice}</p>
      <p>Would you like us to email you our lowest Breakdown cover prices?</p>`;
    },
    options () {
      return this.constants.YES_NO;
    },
  },
  methods: {
    async getBreakdownPrice () {
      try {
        const response = await this.$api.getBreakdownPrice();

        if (response.status !== 'success') throw new Error(response.error);

        this.breakdownPrice = response.data.breakdownPrice;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
